import { Layout } from '@/components/layout/Layout';
import { HeroSection } from '@/components/home/HeroSection';
import { ProblemsSection } from '@/components/home/ProblemsSection';
import { PromiseSection } from '@/components/home/PromiseSection';
import { SolutionsPreview } from '@/components/home/SolutionsPreview';
import { MethodPreview } from '@/components/home/MethodPreview';
import { TestimonialsSection } from '@/components/home/TestimonialsSection';
import { CTASection } from '@/components/home/CTASection';

export default function HomePage() {
  return (
    <Layout>
      <HeroSection />
      <ProblemsSection />
      <PromiseSection />
      <SolutionsPreview />
      <MethodPreview />
      <TestimonialsSection />
      <CTASection />
    </Layout>
  );
}
